<template>
  <div class="account">
    <p class="account_p  wow fadeInUp">媒体账号关注</p>
    <div class="accountCon clearfix  wow fadeInUp">
      <div class="acc_li">
          <div class="acc_li_tp">
            <img src="~@/assets/image/erm1.png" class="erm1" />
          </div>
          <div class="acc_li_bt"> 
            <img src="~@/assets/image/er1.png" class="er1" />
          </div>
          <p class="acc_li_p">更多新鲜事在这里</p>
      </div>
      <div class="acc_li">
          <div class="acc_li_tp">
            <img src="~@/assets/image/erm2.png" class="erm1" />
          </div>
          <div class="acc_li_bt">
            <img src="~@/assets/image/er2.png" class="er1" />
          </div>
          <p class="acc_li_p">更多新资讯在这里</p>
      </div>
      <div class="acc_li">
          <div class="acc_li_tp">
            <img src="~@/assets/image/erm3.png" class="erm1" />
          </div>
          <div class="acc_li_bt">
            <img src="~@/assets/image/er3.png" class="er1" />
          </div>
          <p class="acc_li_p">更多新内容在这里</p>
      </div>
      <div class="acc_li">
          <div class="acc_li_tp">
            <img src="~@/assets/image/erm4.png" class="erm1" />
          </div>
          <div class="acc_li_bt">
            <img src="~@/assets/image/er4.png" class="er1" />
          </div>
          <p class="acc_li_p">发现真实车主生活</p>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
  export default {
    data () {
      return {


      }
    },
    created () {
    },

    mounted () {
// 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()
    })
    },
    methods: {


    },
  }
</script>


// WEBPACK FOOTER //
// src/components/home/account.vue